// source: livongo/protobuf/grpc/external/food/focus.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var livongo_protobuf_common_types_absoluteTimestamp_pb = require('../../../../../livongo/protobuf/common/types/absoluteTimestamp_pb.js');
goog.object.extend(proto, livongo_protobuf_common_types_absoluteTimestamp_pb);
var livongo_protobuf_common_types_date_pb = require('../../../../../livongo/protobuf/common/types/date_pb.js');
goog.object.extend(proto, livongo_protobuf_common_types_date_pb);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogOption', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.MetricStatus', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.MetricStatus.Values', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.WeightGoal', null, global);
goog.exportSymbol('proto.com.livongo.protobuf.grpc.external.food.WeightGoal.Values', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.repeatedFields_, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.displayName = 'proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.MetricStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.MetricStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.MetricStatus.displayName = 'proto.com.livongo.protobuf.grpc.external.food.MetricStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.displayName = 'proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.displayName = 'proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.displayName = 'proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.livongo.protobuf.grpc.external.food.WeightGoal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.livongo.protobuf.grpc.external.food.WeightGoal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.livongo.protobuf.grpc.external.food.WeightGoal.displayName = 'proto.com.livongo.protobuf.grpc.external.food.WeightGoal';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    selectedOnly: (f = msg.getSelectedOnly()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    focusActiveTime: (f = msg.getFocusActiveTime()) && livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest;
  return proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSelectedOnly(value);
      break;
    case 3:
      var value = new livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp;
      reader.readMessage(value,livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.deserializeBinaryFromReader);
      msg.setFocusActiveTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSelectedOnly();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getFocusActiveTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue selected_only = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.getSelectedOnly = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.setSelectedOnly = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.clearSelectedOnly = function() {
  return this.setSelectedOnly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.hasSelectedOnly = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional com.livongo.protobuf.common.types.AbsoluteTimestamp focus_active_time = 3;
 * @return {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.getFocusActiveTime = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_absoluteTimestamp_pb.AbsoluteTimestamp, 3));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.AbsoluteTimestamp|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.setFocusActiveTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.clearFocusActiveTime = function() {
  return this.setFocusActiveTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesRequest.prototype.hasFocusActiveTime = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.toObject = function(includeInstance, msg) {
  var f, obj = {
    focusId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    focusCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userFocusId: (f = msg.getUserFocusId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    focusOptionsList: jspb.Message.toObjectList(msg.getFocusOptionsList(),
    proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFocusId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFocusCode(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setUserFocusId(value);
      break;
    case 4:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogOption;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.deserializeBinaryFromReader);
      msg.addFocusOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFocusId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getFocusCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserFocusId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getFocusOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 focus_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.getFocusId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.setFocusId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string focus_code = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.getFocusCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.setFocusCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Int32Value user_focus_id = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.getUserFocusId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.setUserFocusId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.clearUserFocusId = function() {
  return this.setUserFocusId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.hasUserFocusId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated FoodLogOption focus_options = 4;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption>}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.getFocusOptionsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogOption, 4));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.setFocusOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.addFocusOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.com.livongo.protobuf.grpc.external.food.FoodLogOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.prototype.clearFocusOptionsList = function() {
  return this.setFocusOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    optionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    optionCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userOptionId: (f = msg.getUserOptionId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    defaultSelected: (f = msg.getDefaultSelected()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    selected: (f = msg.getSelected()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    target: (f = msg.getTarget()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogOption;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOptionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionCode(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setUserOptionId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setDefaultSelected(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSelected(value);
      break;
    case 6:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.deserializeBinaryFromReader);
      msg.setTarget(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOptionId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOptionCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserOptionId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getDefaultSelected();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getSelected();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getTarget();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 option_id = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.getOptionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.setOptionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string option_code = 2;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.getOptionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.setOptionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Int32Value user_option_id = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.getUserOptionId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.setUserOptionId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.clearUserOptionId = function() {
  return this.setUserOptionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.hasUserOptionId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue default_selected = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.getDefaultSelected = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.setDefaultSelected = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.clearDefaultSelected = function() {
  return this.setDefaultSelected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.hasDefaultSelected = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue selected = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.getSelected = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.setSelected = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.clearSelected = function() {
  return this.setSelected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.hasSelected = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional FoodLogTarget target = 6;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.getTarget = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget, 6));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.setTarget = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogOption} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.clearTarget = function() {
  return this.setTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogOption.prototype.hasTarget = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    targetId: (f = msg.getTargetId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    selected: (f = msg.getSelected()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    targetValue: (f = msg.getTargetValue()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    min: (f = msg.getMin()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    max: (f = msg.getMax()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    unit: (f = msg.getUnit()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCode(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTargetId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setSelected(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTargetValue(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setUnit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getSelected();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getTargetValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getUnit();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string target_code = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.getTargetCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.setTargetCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Int32Value target_id = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.getTargetId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.setTargetId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.clearTargetId = function() {
  return this.setTargetId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.hasTargetId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.BoolValue selected = 3;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.getSelected = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 3));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.setSelected = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.clearSelected = function() {
  return this.setSelected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.hasSelected = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Int32Value target_value = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.getTargetValue = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.setTargetValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.clearTargetValue = function() {
  return this.setTargetValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.hasTargetValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value min = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.getMin = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.hasMin = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Int32Value max = 6;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.getMax = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 6));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.hasMax = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue unit = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.getUnit = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.setUnit = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.clearUnit = function() {
  return this.setUnit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogTarget.prototype.hasUnit = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    parent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    focusesList: jspb.Message.toObjectList(msg.getFocusesList(),
    proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse;
  return proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParent(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.deserializeBinaryFromReader);
      msg.addFocuses(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFocusesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.serializeBinaryToWriter
    );
  }
};


/**
 * optional string parent = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.prototype.getParent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.prototype.setParent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated FoodLogFocus focuses = 2;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus>}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.prototype.getFocusesList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus, 2));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.prototype.setFocusesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus}
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.prototype.addFocuses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.ListFoodLogFocusesResponse.prototype.clearFocusesList = function() {
  return this.setFocusesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    focus: (f = msg.getFocus()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest;
  return proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.deserializeBinaryFromReader);
      msg.setFocus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFocus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FoodLogFocus focus = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.prototype.getFocus = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.prototype.setFocus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.prototype.clearFocus = function() {
  return this.setFocus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusRequest.prototype.hasFocus = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    focus: (f = msg.getFocus()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse;
  return proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.deserializeBinaryFromReader);
      msg.setFocus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFocus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FoodLogFocus focus = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.prototype.getFocus = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogFocus|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.prototype.setFocus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.prototype.clearFocus = function() {
  return this.setFocus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.SaveFoodLogFocusResponse.prototype.hasFocus = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    userFocusId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest;
  return proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUserFocusId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserFocusId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 user_focus_id = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.prototype.getUserFocusId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.DeleteFoodLogFocusRequest.prototype.setUserFocusId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    summaryDate: (f = msg.getSummaryDate()) && livongo_protobuf_common_types_date_pb.Date.toObject(includeInstance, f),
    tzOffset: (f = msg.getTzOffset()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new livongo_protobuf_common_types_date_pb.Date;
      reader.readMessage(value,livongo_protobuf_common_types_date_pb.Date.deserializeBinaryFromReader);
      msg.setSummaryDate(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTzOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSummaryDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      livongo_protobuf_common_types_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTzOffset();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional com.livongo.protobuf.common.types.Date summary_date = 2;
 * @return {?proto.com.livongo.protobuf.common.types.Date}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.getSummaryDate = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.Date} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_date_pb.Date, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.Date|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.setSummaryDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.clearSummaryDate = function() {
  return this.setSummaryDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.hasSummaryDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Int32Value tz_offset = 3;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.getTzOffset = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 3));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.setTzOffset = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.clearTzOffset = function() {
  return this.setTzOffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesRequest.prototype.hasTzOffset = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    summary: (f = msg.getSummary()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse;
  return proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FoodLogNutritionSummaries summary = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.prototype.getSummary = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    startDate: (f = msg.getStartDate()) && livongo_protobuf_common_types_date_pb.Date.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && livongo_protobuf_common_types_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new livongo_protobuf_common_types_date_pb.Date;
      reader.readMessage(value,livongo_protobuf_common_types_date_pb.Date.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 3:
      var value = new livongo_protobuf_common_types_date_pb.Date;
      reader.readMessage(value,livongo_protobuf_common_types_date_pb.Date.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      livongo_protobuf_common_types_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      livongo_protobuf_common_types_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional com.livongo.protobuf.common.types.Date start_date = 2;
 * @return {?proto.com.livongo.protobuf.common.types.Date}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.getStartDate = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.Date} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_date_pb.Date, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.Date|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional com.livongo.protobuf.common.types.Date end_date = 3;
 * @return {?proto.com.livongo.protobuf.common.types.Date}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.getEndDate = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.Date} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_date_pb.Date, 3));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.Date|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesRequest.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nutritionSummariesList: jspb.Message.toObjectList(msg.getNutritionSummariesList(),
    proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse;
  return proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.deserializeBinaryFromReader);
      msg.addNutritionSummaries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNutritionSummariesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated FoodLogNutritionSummaries nutrition_summaries = 2;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries>}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.prototype.getNutritionSummariesList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries, 2));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.prototype.setNutritionSummariesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries}
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.prototype.addNutritionSummaries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetNutritionSummariesByDatesResponse.prototype.clearNutritionSummariesList = function() {
  return this.setNutritionSummariesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.toObject = function(includeInstance, msg) {
  var f, obj = {
    calorieSummary: (f = msg.getCalorieSummary()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.toObject(includeInstance, f),
    microNutrientsList: jspb.Message.toObjectList(msg.getMicroNutrientsList(),
    proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.toObject, includeInstance),
    summaryDate: (f = msg.getSummaryDate()) && livongo_protobuf_common_types_date_pb.Date.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.deserializeBinaryFromReader);
      msg.setCalorieSummary(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.deserializeBinaryFromReader);
      msg.addMicroNutrients(value);
      break;
    case 3:
      var value = new livongo_protobuf_common_types_date_pb.Date;
      reader.readMessage(value,livongo_protobuf_common_types_date_pb.Date.deserializeBinaryFromReader);
      msg.setSummaryDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCalorieSummary();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.serializeBinaryToWriter
    );
  }
  f = message.getMicroNutrientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.serializeBinaryToWriter
    );
  }
  f = message.getSummaryDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      livongo_protobuf_common_types_date_pb.Date.serializeBinaryToWriter
    );
  }
};


/**
 * optional FoodLogCalorieSummary calorie_summary = 1;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.getCalorieSummary = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary, 1));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.setCalorieSummary = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.clearCalorieSummary = function() {
  return this.setCalorieSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.hasCalorieSummary = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated FoodLogNutrientSummary micro_nutrients = 2;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary>}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.getMicroNutrientsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary, 2));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.setMicroNutrientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.addMicroNutrients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.clearMicroNutrientsList = function() {
  return this.setMicroNutrientsList([]);
};


/**
 * optional com.livongo.protobuf.common.types.Date summary_date = 3;
 * @return {?proto.com.livongo.protobuf.common.types.Date}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.getSummaryDate = function() {
  return /** @type{?proto.com.livongo.protobuf.common.types.Date} */ (
    jspb.Message.getWrapperField(this, livongo_protobuf_common_types_date_pb.Date, 3));
};


/**
 * @param {?proto.com.livongo.protobuf.common.types.Date|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.setSummaryDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.clearSummaryDate = function() {
  return this.setSummaryDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutritionSummaries.prototype.hasSummaryDate = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    calorieVal: (f = msg.getCalorieVal()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.toObject(includeInstance, f),
    targetValue: (f = msg.getTargetValue()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    breakdownsList: jspb.Message.toObjectList(msg.getBreakdownsList(),
    proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.deserializeBinaryFromReader);
      msg.setCalorieVal(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setTargetValue(value);
      break;
    case 3:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.deserializeBinaryFromReader);
      msg.addBreakdowns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCalorieVal();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.serializeBinaryToWriter
    );
  }
  f = message.getTargetValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getBreakdownsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.serializeBinaryToWriter
    );
  }
};


/**
 * optional FoodLogNutrientSummary calorie_val = 1;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.getCalorieVal = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary, 1));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.setCalorieVal = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.clearCalorieVal = function() {
  return this.setCalorieVal(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.hasCalorieVal = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Int32Value target_value = 2;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.getTargetValue = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 2));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.setTargetValue = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.clearTargetValue = function() {
  return this.setTargetValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.hasTargetValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated FoodLogNutrientBreakdown breakdowns = 3;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown>}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.getBreakdownsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown, 3));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.setBreakdownsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.addBreakdowns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogCalorieSummary.prototype.clearBreakdownsList = function() {
  return this.setBreakdownsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    nutrientCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    unit: jspb.Message.getFieldWithDefault(msg, 3, ""),
    min: (f = msg.getMin()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    max: (f = msg.getMax()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
    statusCode: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNutrientCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnit(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMin(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setMax(value);
      break;
    case 6:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus.Values} */ (reader.readEnum());
      msg.setStatusCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNutrientCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getUnit();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMin();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getMax();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getStatusCode();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string nutrient_code = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.getNutrientCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.setNutrientCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string unit = 3;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.getUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.setUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Int32Value min = 4;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.getMin = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 4));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.setMin = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.clearMin = function() {
  return this.setMin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.hasMin = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Int32Value max = 5;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.getMax = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 5));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.setMax = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.clearMax = function() {
  return this.setMax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.hasMax = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MetricStatus.Values status_code = 6;
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus.Values}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.getStatusCode = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus.Values} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.prototype.setStatusCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.toObject = function(includeInstance, msg) {
  var f, obj = {
    calorieBreakdown: (f = msg.getCalorieBreakdown()) && proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.toObject(includeInstance, f),
    totalCalorie: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    calorieUnit: jspb.Message.getFieldWithDefault(msg, 3, ""),
    totalWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    weightUnit: jspb.Message.getFieldWithDefault(msg, 5, ""),
    detailsList: jspb.Message.toObjectList(msg.getDetailsList(),
    proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.deserializeBinaryFromReader);
      msg.setCalorieBreakdown(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalCalorie(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalorieUnit(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalWeight(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeightUnit(value);
      break;
    case 6:
      var value = new proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.deserializeBinaryFromReader);
      msg.addDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCalorieBreakdown();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary.serializeBinaryToWriter
    );
  }
  f = message.getTotalCalorie();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCalorieUnit();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTotalWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getWeightUnit();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDetailsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.serializeBinaryToWriter
    );
  }
};


/**
 * optional FoodLogNutrientSummary calorie_breakdown = 1;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.getCalorieBreakdown = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary, 1));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientSummary|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.setCalorieBreakdown = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.clearCalorieBreakdown = function() {
  return this.setCalorieBreakdown(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.hasCalorieBreakdown = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional double total_calorie = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.getTotalCalorie = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.setTotalCalorie = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string calorie_unit = 3;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.getCalorieUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.setCalorieUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double total_weight = 4;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.getTotalWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.setTotalWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string weight_unit = 5;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.getWeightUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.setWeightUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated FoodLogBreakdownDetail details = 6;
 * @return {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail>}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.getDetailsList = function() {
  return /** @type{!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail, 6));
};


/**
 * @param {!Array<!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail>} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.setDetailsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.addDetails = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogNutrientBreakdown.prototype.clearDetailsList = function() {
  return this.setDetailsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    nutrientCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    calorie: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    calorieUnit: jspb.Message.getFieldWithDefault(msg, 3, ""),
    weight: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    weightUnit: jspb.Message.getFieldWithDefault(msg, 5, ""),
    percentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail;
  return proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNutrientCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCalorie(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalorieUnit(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWeight(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setWeightUnit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNutrientCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCalorie();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getCalorieUnit();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getWeightUnit();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional string nutrient_code = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.getNutrientCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.setNutrientCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double calorie = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.getCalorie = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.setCalorie = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional string calorie_unit = 3;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.getCalorieUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.setCalorieUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double weight = 4;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.getWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.setWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional string weight_unit = 5;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.getWeightUnit = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.setWeightUnit = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double percentage = 6;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.FoodLogBreakdownDetail.prototype.setPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.MetricStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.MetricStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.MetricStatus.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus}
 */
proto.com.livongo.protobuf.grpc.external.food.MetricStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.MetricStatus;
  return proto.com.livongo.protobuf.grpc.external.food.MetricStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus}
 */
proto.com.livongo.protobuf.grpc.external.food.MetricStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.MetricStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.MetricStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.MetricStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.MetricStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.food.MetricStatus.Values = {
  INVALID: 0,
  TOO_FEW_FOOD: 1,
  TOO_LOW: 2,
  BIT_LOW: 3,
  IN_RANGE: 4,
  VERY_GOOD: 5,
  BIT_HIGH: 6,
  TOO_HIGH: 7
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    activityMultiplier: jspb.Message.getFieldWithDefault(msg, 2, 0),
    currentWeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    height: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    goal: jspb.Message.getFieldWithDefault(msg, 5, 0),
    lbsPerWeek: (f = msg.getLbsPerWeek()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.Values} */ (reader.readEnum());
      msg.setActivityMultiplier(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCurrentWeight(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeight(value);
      break;
    case 5:
      var value = /** @type {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal.Values} */ (reader.readEnum());
      msg.setGoal(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setLbsPerWeek(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getActivityMultiplier();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCurrentWeight();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getGoal();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getLbsPerWeek();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ActivityMultiplier.Values activity_multiplier = 2;
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.Values}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.getActivityMultiplier = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.Values} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.setActivityMultiplier = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional double current_weight = 3;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.getCurrentWeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.setCurrentWeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double height = 4;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.setHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional WeightGoal.Values goal = 5;
 * @return {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal.Values}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.getGoal = function() {
  return /** @type {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal.Values} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal.Values} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.setGoal = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional google.protobuf.DoubleValue lbs_per_week = 6;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.getLbsPerWeek = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 6));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.setLbsPerWeek = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.clearLbsPerWeek = function() {
  return this.setLbsPerWeek(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetRequest.prototype.hasLbsPerWeek = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    target: jspb.Message.getFieldWithDefault(msg, 1, 0),
    min: jspb.Message.getFieldWithDefault(msg, 2, 0),
    max: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse;
  return proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTarget(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMin(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTarget();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMin();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMax();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 target = 1;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.prototype.getTarget = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.prototype.setTarget = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 min = 2;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.prototype.getMin = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.prototype.setMin = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 max = 3;
 * @return {number}
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.prototype.getMax = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GenerateCalorieTargetResponse.prototype.setMax = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest;
  return proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    heightWeightInfo: (f = msg.getHeightWeightInfo()) && proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse;
  return proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo;
      reader.readMessage(value,proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.deserializeBinaryFromReader);
      msg.setHeightWeightInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHeightWeightInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional HeightWeightInfo height_weight_info = 2;
 * @return {?proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.prototype.getHeightWeightInfo = function() {
  return /** @type{?proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo} */ (
    jspb.Message.getWrapperField(this, proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo, 2));
};


/**
 * @param {?proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.prototype.setHeightWeightInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.prototype.clearHeightWeightInfo = function() {
  return this.setHeightWeightInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.GetUserHeightWeightInfoResponse.prototype.hasHeightWeightInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    height: (f = msg.getHeight()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f),
    weight: (f = msg.getWeight()) && google_protobuf_wrappers_pb.DoubleValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo}
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo;
  return proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo}
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setHeight(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.DoubleValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.DoubleValue.deserializeBinaryFromReader);
      msg.setWeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeight();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
  f = message.getWeight();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.DoubleValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.DoubleValue height = 1;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.getHeight = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 1));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.setHeight = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.clearHeight = function() {
  return this.setHeight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.hasHeight = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.DoubleValue weight = 2;
 * @return {?proto.google.protobuf.DoubleValue}
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.getWeight = function() {
  return /** @type{?proto.google.protobuf.DoubleValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.DoubleValue, 2));
};


/**
 * @param {?proto.google.protobuf.DoubleValue|undefined} value
 * @return {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo} returns this
*/
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.setWeight = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo} returns this
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.clearWeight = function() {
  return this.setWeight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.livongo.protobuf.grpc.external.food.HeightWeightInfo.prototype.hasWeight = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier}
 */
proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier;
  return proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier}
 */
proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.food.ActivityMultiplier.Values = {
  INVALID: 0,
  SEDENTARY: 1,
  LOW_ACTIVE: 2,
  ACTIVE: 3,
  VERY_ACTIVE: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.com.livongo.protobuf.grpc.external.food.WeightGoal.prototype.toObject = function(opt_includeInstance) {
  return proto.com.livongo.protobuf.grpc.external.food.WeightGoal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.WeightGoal.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal}
 */
proto.com.livongo.protobuf.grpc.external.food.WeightGoal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.livongo.protobuf.grpc.external.food.WeightGoal;
  return proto.com.livongo.protobuf.grpc.external.food.WeightGoal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal}
 */
proto.com.livongo.protobuf.grpc.external.food.WeightGoal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.livongo.protobuf.grpc.external.food.WeightGoal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.com.livongo.protobuf.grpc.external.food.WeightGoal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.livongo.protobuf.grpc.external.food.WeightGoal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.livongo.protobuf.grpc.external.food.WeightGoal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.com.livongo.protobuf.grpc.external.food.WeightGoal.Values = {
  INVALID: 0,
  GAIN: 1,
  LOSE: 2,
  MAINTAIN: 3
};

goog.object.extend(exports, proto.com.livongo.protobuf.grpc.external.food);
